import { useMemo } from 'react'

import { useQuery } from '@tabeeb/shared/utils/hooks'

import useFormFolders from './useFormFolders'

const useCurrentFolder = () => {
  const folderIdParam = useQuery().get('folderId')

  let parsedFolderId = folderIdParam ? Number(folderIdParam) : null
  if (Number.isNaN(parsedFolderId)) {
    parsedFolderId = null
  }

  const { formFolders } = useFormFolders()

  const currentFolder = useMemo(() => {
    return formFolders?.find((f) => f.FolderId === parsedFolderId) || null
  }, [formFolders, parsedFolderId])

  return useMemo(
    () => ({
      currentFolderId: currentFolder?.FolderId ?? null,
      currentFolderName: currentFolder?.Name ?? null,
      currentFolderOwnerId: currentFolder?.UserId ?? null,
    }),
    [currentFolder?.FolderId, currentFolder?.Name, currentFolder?.UserId]
  )
}

export default useCurrentFolder
